export const ResetService = ({ email, password, BeURL, setConfirm, Setmessage, otp }) => {

    fetch(`${BeURL}/reset-password`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ email, password, otp })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                Setmessage(data.message)
                setConfirm(true)
            }
            else {
                Setmessage(data.message)
                setConfirm(false)
            }
        })
        .catch(err => {
            console.log('Error in reset Password:', err)
            alert('Trouble in connecting to the Server! Please try again later.')
        })

}
